var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-empty',{attrs:{"description":_vm.item.description || '暂无数据可显示',"image":_vm.img}})
}
var staticRenderFns = []

export { render, staticRenderFns }